import React from 'react';
import tw from 'twin.macro';
import { CJEvent } from 'types/event';
import { ClassroomsOrg } from 'types/school';
import Tooltip2 from 'components/Tooltip2';
import { StatusButton } from 'components/Buttons/StatusButton';
import { useUpdateCJSeance } from 'containers/CahierJournal/queries/useUpdateCJSeance';
import { useUser } from 'containers/App/context/useUser';
import { useTranslation } from 'react-i18next';
import { getTitleColorFromTagColor } from 'components/colors';
import { Tag } from 'components/Tag';

interface Props {
  event: CJEvent;
  print?: boolean;
  duration?: string;
  classroomsToDisplay?: string;
  classroomsOrg: ClassroomsOrg;
  className?: string;
  shouldColorTitle?: boolean;
  showStatusToggle?: boolean;
}

export function TitleLineNew(props: Props) {
  const { print, event, className, shouldColorTitle, showStatusToggle } = props;
  const { t } = useTranslation(['cahierJournal']);
  const { guestMode } = useUser();
  const updateEvent = useUpdateCJSeance();
  const tagColor = event.tag?.color;
  return (
    <div tw="flex items-start flex-wrap gap-x-2" className={className}>
      {guestMode?.permission !== 'read' && showStatusToggle && (
        <Tooltip2
          tw="print:hidden mr-0.5"
          label={
            event.status === 'done'
              ? t('cahierJournal:actions.markAsNotDone')
              : t('cahierJournal:actions.markAsDone')
          }
        >
          <StatusButton
            role="presentation"
            tw="w-6 h-6"
            status={event.status === 'open' ? 'todo' : event.status}
            onClick={async e => {
              e.stopPropagation();
              await updateEvent({
                event: {
                  ...event,
                  status: event.status === 'done' ? 'open' : 'done',
                },
              });
            }}
          />
        </Tooltip2>
      )}
      <div
        className="seance-title"
        css={[
          tw`font-bold text-lg min-w-0 flex flex-wrap gap-x-2 gap-y-1 items-center`,
          event.status === 'done' && tw`opacity-50`,
          print && event.type === 'break' && tw`text-neutral-intense`,
          tagColor === 'white' && tw`text-neutral-intense`,
        ]}
      >
        <h4
          css={[
            shouldColorTitle && getTitleColorFromTagColor(event.tag?.color),
          ]}
          tw="leading-tight min-w-0 break-words"
        >
          {event.title}
        </h4>
        {event.isDemo && (
          <Tag data-testid="demo-tag" color="gris-quiet">
            {t('cahierJournal:labels.example')}
          </Tag>
        )}
      </div>
    </div>
  );
}
